export default Object.freeze({
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1920,
})
